import React, { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes as RouterRoutes, useLocation } from "react-router-dom";

import UnverifiedMailRoute from './utility/UnverifiedMailRoute';
import PrivateRoute from './utility/PrivateRoute';
import PublicRoute from './utility/PublicRoute';
import ModernHome from "./components/Home";
import About from "./components/About";
import PromotionTool from "./components/PromotionTool";
import News from "./components/News";
import Certification from "./components/Certification";

import Faq from "./components/Faq";
import Term from "./components/Term";
import Social from "./components/Social";
import Salary from "./components/Salary";
import Agent from "./components/Agent";
import Map from "./components/Map";
import Swap from "./components/Swap";
import Bonus from "./components/Bonus";
import Bank from "./components/Bank";
import Wallet from "./components/Wallet";
import ChangePin from "./components/ChangePin";
import Phone from "./components/Phone";
import GoogleAuth from "./components/GoogleAuth";
import RefLink from "./components/RefLink";

import ReinvestBonus from "./components/ReinvestBonus";

import FX from "./components/FX";


import AllPages from "./components/AllPages";
import BillPay from "./components/BillPay";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import Carts from "./components/Carts";
import Components from "./components/Components";
import ComponentsAccordion from "./components/ComponentsAccordion";
import ComponentsAlerts from "./components/ComponentsAlerts";
import ComponentsButtons from "./components/ComponentsButtons";
import ComponentsModals from "./components/ComponentsModals";
import ComponentsNotifications from "./components/ComponentsNotifications";
import ComponentsProgress from "./components/ComponentsProgress";
import ComponentsTabs from "./components/ComponentsTabs";
// import ComponentsTooltip from "./components/ComponentsTooltip";
import Contact from "./components/Contact";
import Notification from "./components/Notification";
import Saving from "./components/Saving";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import VerifyEmail from './components/VerifyEmail';
import ForgetPassword from './components/ForgetPassword';


import Transaction from "./components/Transaction";
import TransactionDetails from "./components/TransactionDetails";
import Mine from "./components/Mine";
import PersonalInformation from "./components/PersonalInformation";

import Bot from "./components/Bot";

import Trade from "./components/Trade";
import Arbitrage from "./components/Arbitrage";

// import TradeBots from "./components/Trade/TradeBots";

import Asset from "./components/Asset";
import P2P from "./components/P2P";
import AllP2P from "./components/AllP2P";
import Chats from "./components/Chats";
import KYC from "./components/KYC";
import AllKYC from "./components/KYC/AllKYC";
import ChangePassword from "./components/ChangePassword";


import Testimony from "./components/Testimony";


// import TradeHistory from "./components/Trade-history";
import Referrals from "./components/Referrals";
import TeamEarning from "./components/TeamEarning";
// import Security from "./components/Security";


// import DepositHistory from "./components/Deposits/History";
import Deposit from "./components/Deposits/New";

import Withdraw from "./components/Withdraw/New";

import Transfer from "./components/Transfer/New";


// import WithdrawalHistory from "./components/Withdrawals/History";
// import Withdraw from "./components/Withdrawals/New";


import DepositHistory from "./components/Deposit-history";
import WithdrawalHistory from "./components/Withdrawal-history";
import TransferHistory from "./components/Transfer-history";


import UserVerification from "./components/UserVerification";
import { useSelector, useDispatch } from 'react-redux';
import { authActions } from './redux/actions';
import { userSelect, allRemoteSettingsSelect } from './redux/selectors/index';
import LoadingOverlay from 'react-loading-overlay';





function AppRoutes() {


    const dispatch = useDispatch();
    const userData = useSelector(userSelect);
    const [loading, setLoading] = React.useState(true);
    // const { pathname } = useLocation();

    useEffect(() => {
        dispatch(authActions.onRefreshSystemData("system/refresh", 10, {}, response => {
            setLoading(false)
        }))
    }, [userData?.email])




    // // Setting page scroll to 0 when changing the route
    // useEffect(() => {
    //     document.documentElement.scrollTop = 0;
    //     document.scrollingElement.scrollTop = 0;
    // }, [pathname]);

    return (<>


        {!loading && <BrowserRouter>
            <RouterRoutes>
                {/* <Route path={'/all-pages'} element={<AllPages />} />
                <Route path={'/bill-pay'} element={<BillPay />} />
                <Route path={'/blog'} element={<Blog />} />
                <Route path={'/blog-details'} element={<BlogDetails />} />
                <Route path={'/carts'} element={<Carts />} />
                <Route path={'/components'} element={<Components />} />
                <Route path={'/components-accordion'} element={<ComponentsAccordion />} />
                <Route path={'/components-alerts'} element={<ComponentsAlerts />} />
                <Route path={'/components-buttons'} element={<ComponentsButtons />} />
                <Route path={'/components-modal'} element={<ComponentsModals />} />
                <Route path={'/components-notifications'} element={<ComponentsNotifications />} />
                <Route path={'/components-progress'} element={<ComponentsProgress />} />
                <Route path={'/components-tabs'} element={<ComponentsTabs />} /> */}
                {/*<Route path={'/components-tooltip'} element={<ComponentsTooltip />} />*/}
                {/* <Route path={'/contact'} element={<Contact />} /> */}
                {/* <Route path={'/notification'} element={<Notification />} /> */}
                {/* <Route path={'/saving'} element={<Saving />} /> */}


                <Route path={'/'} element={<PrivateRoute><ModernHome /></PrivateRoute>} />
                {/* <PrivateRoute exact path={'/'} component={ModernHome} /> */}
                <Route path={'/about'} element={<About />} />
                {/* <Route path={'/promotion-tool'} element={<PromotionTool />} /> */}
                {/* <Route path={'/certification'} element={<Certification />} /> */}
                <Route path={'/news'} element={<News />} />

                <Route path={'/faq'} element={<Faq />} />
                <Route path={'/term'} element={<Term />} />


                <Route path={'/signin'} element={<PublicRoute><Signin /></PublicRoute>} />
                <Route path={'/signup'} element={<PublicRoute><Signup /></PublicRoute>} />
                <Route path={'/reset-password'} element={<PublicRoute><ForgetPassword /></PublicRoute>} />
                <Route path={'/verify-email'} element={<UnverifiedMailRoute><VerifyEmail /></UnverifiedMailRoute>} />
                <Route path={'/user-verification'} element={<UnverifiedMailRoute><UserVerification /></UnverifiedMailRoute>} />


                {/* <Route path={'/mine'} element={<PrivateRoute><Mine /></PrivateRoute>} /> */}
                {/* <Route path={'/feedback'} element={<PrivateRoute><Testimony /></PrivateRoute>} /> */}
                {/* <Route path={'/bot'} element={<PrivateRoute><Bot /></PrivateRoute>} /> */}
                {/* <Route path={'/securities'} element={<PrivateRoute><Security /></PrivateRoute>} /> */}
                {/* <Route path={'/social'} element={<PrivateRoute><Social /></PrivateRoute>} /> */}
                {/* <Route path={'/trade-record'} element={<PrivateRoute><TradeHistory /></PrivateRoute>} /> */}
                {/* <Route path={'/trade/bots'} element={<PrivateRoute><TradeBots /></PrivateRoute>} /> */}

                {/* <Route path={'/asset'} element={<PrivateRoute><Asset /></PrivateRoute>} /> */}
                {/* <Route path={'/chat'} element={<PrivateRoute><Chats /></PrivateRoute>} /> */}
                {/* <Route path={'/kyc'} element={<PrivateRoute><KYC /></PrivateRoute>} /> */}
                {/* <Route path={'/all-kyc'} element={<PrivateRoute><AllKYC /></PrivateRoute>} /> */}

                <Route path={'/transactions'} element={<PrivateRoute><Arbitrage /></PrivateRoute>} />
                <Route path={'/new/trade'} element={<PrivateRoute><Trade /></PrivateRoute>} />
                <Route path={'/personal-information'} element={<PrivateRoute><PersonalInformation /></PrivateRoute>} />

                <Route path={'/change-password'} element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
                <Route path={'/deposit'} element={<PrivateRoute><Deposit /></PrivateRoute>} />
                <Route path={'/Deposit-records'} element={<PrivateRoute><DepositHistory /></PrivateRoute>} />
                <Route path={'/withdraw'} element={<PrivateRoute><Withdraw /></PrivateRoute>} />
                <Route path={'/withdrawal-records'} element={<PrivateRoute><WithdrawalHistory /></PrivateRoute>} />

                <Route path={'/ref-link'} element={<PrivateRoute><RefLink /></PrivateRoute>} />
                <Route path={'/affiliate-center'} element={<PrivateRoute><TeamEarning /></PrivateRoute>} />

                <Route path={'/bank'} element={<PrivateRoute><Bank /></PrivateRoute>} />
                <Route path={'/wallet'} element={<PrivateRoute><Wallet /></PrivateRoute>} />
                <Route path={'/change-pin'} element={<PrivateRoute><ChangePin /></PrivateRoute>} />
                <Route path={'/phone'} element={<PrivateRoute><Phone /></PrivateRoute>} />

                {/* <Route path={'/transfer'} element={<PrivateRoute><Transfer /></PrivateRoute>} /> */}
                {/* <Route path={'/transfer-records'} element={<PrivateRoute><TransferHistory /></PrivateRoute>} /> */}

                {/* <Route path={'/team'} element={<PrivateRoute><Referrals /></PrivateRoute>} /> */}

                {/* <Route path={'/salary'} element={<PrivateRoute><Salary /></PrivateRoute>} /> */}
                {/* <Route path={'/agent'} element={<PrivateRoute><Agent /></PrivateRoute>} /> */}
                {/* <Route path={'/address'} element={<PrivateRoute><Map /></PrivateRoute>} /> */}
                {/* <Route path={'/p2p'} element={<PrivateRoute><P2P /></PrivateRoute>} /> */}
                {/* <Route path={'/swap'} element={<PrivateRoute><Swap /></PrivateRoute>} /> */}

                {/* <Route path={'/google-auth'} element={<PrivateRoute><GoogleAuth /></PrivateRoute>} /> */}


                {/* I removed bonus because the referral bonus drop to the balance directly, you can change that from Referral.php */}
                {/* <Route path={'/bonus'} element={<PrivateRoute><Bonus /></PrivateRoute>} /> */}
                {/* <Route path={'/reinvest-bonus'} element={<PrivateRoute><ReinvestBonus /></PrivateRoute>} /> */}


                {/*<PrivateRoute exact path={'/network'} component={(props) => (<Referrals {...props} />)} />*/}


            </RouterRoutes>
        </BrowserRouter>}



        {loading && <div className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-cyan-400 shadow-lg shadow-cyan-400/50"></div>
                <p className="text-cyan-300 mt-4 text-lg font-semibold">{'Please wait...'}</p>
                <div className="mt-2 w-64 bg-gray-700 rounded-full h-1">
                    <div className="bg-gradient-to-r from-cyan-400 to-purple-500 h-1 rounded-full animate-pulse" style={{ width: '60%' }}></div>
                </div>
            </div>
        </div>}


    </>
    )

}

export default AppRoutes;
